module.exports = __webpack_public_path__ + "static/ClickUp-541de476ec631b77176713da0d42c25b.png";